import React from 'react'
import { useNavigate } from 'react-router-dom';
import WestIcon from '@mui/icons-material/West';

function Back() {
  const navigate = useNavigate();
  return (
    <div
      className="cursor-pointer flex items-center text-[#1E222B] font-[700] text-[15px] hover:opacity-80 transition"
      onClick={() => navigate(-1)}
    >
      <WestIcon sx={{ fontSize: 18 }} /> <span className="pl-2">Back</span>
    </div>
  );
}

export default Back;